// Centralized content & curated imagery for Yadid Advisory
// Copy sourced verbatim from the client Website Copy Deck.

export const IMAGES = {
  heroLibrary:
    "https://images.unsplash.com/photo-1759338449476-326ed8b5eb03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  conversation:
    "https://images.unsplash.com/photo-1774592630528-eca3427a322f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tableMeeting:
    "https://images.unsplash.com/photo-1764391801025-9cee2194f564?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  silhouette:
    "https://images.unsplash.com/photo-1546795708-c962dc089798?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  ledger:
    "https://images.unsplash.com/photo-1760307837453-ce60cb209e52?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  quillDesk:
    "https://images.unsplash.com/photo-1478641300939-0ec5188d3802?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fountainPen:
    "https://images.unsplash.com/photo-1457298483369-0a95d2b17fcd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  columns:
    "https://images.unsplash.com/photo-1551270029-4bc0f7eabf78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facade:
    "https://images.unsplash.com/photo-1640549755250-04d2751c5aba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cloisterLight:
    "https://images.unsplash.com/photo-1781455793251-b69740ac8806?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cloisterArcade:
    "https://images.unsplash.com/photo-1777654661533-d64f5f51987c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cloisterHall:
    "https://images.unsplash.com/photo-1766946127643-3bc297210cb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  jerusalemWindow:
    "https://images.unsplash.com/photo-1768594617607-a3a159789774?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  jerusalemStair:
    "https://images.unsplash.com/photo-1682100139612-2a7d411a91a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  synagogueGold:
    "https://images.unsplash.com/photo-1665751280403-6d76ef305696?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  synagogueRed:
    "https://images.unsplash.com/photo-1755532884009-9607be4adaaf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  krakowStreet:
    "https://images.unsplash.com/photo-1759616143071-af8148e9a378?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  krakowSquare:
    "https://images.unsplash.com/photo-1783407876904-0c76ab50104f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "How We Advise", to: "/how-we-advise" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Yadid Journeys", to: "/journeys" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const METHOD = [
  {
    n: "01",
    title: "Listen",
    lede: "Listen before prescribing.",
    body: "We seek to understand the leader, the institution, the history, the relationships, the opportunity, the pressures, and the questions beneath the stated question.",
    list: [
      "Leadership conversations",
      "Stakeholder interviews",
      "Research",
      "Historical and institutional context",
      "Relationship mapping",
      "Observation",
      "Cultural interpretation",
      "Review of previous decisions and commitments",
    ],
    close: "The objective is not simply to collect information. It is to understand the strategic reality.",
  },
  {
    n: "02",
    title: "Reveal",
    lede: "Bring the real situation into view.",
    body: "Once enough has been heard, the work becomes interpretive. What matters? What is being assumed? Where is the trust? Where is the friction? What opportunities are emerging? What risks are being underestimated? What does the institution need to confront honestly?",
    close: "Yadid helps leaders see what may be difficult to see from inside the situation.",
  },
  {
    n: "03",
    title: "Reimagine",
    lede: "Consider what could become possible.",
    body: "Clarity creates options. Yadid helps leaders explore alternative paths, relationships, partnerships, narratives, structures, and strategic choices.",
    close: "Reimagining is not brainstorming for its own sake. It is disciplined consideration of what becomes possible once the situation is understood more clearly.",
  },
  {
    n: "04",
    title: "Guide",
    lede: "Move from insight to judgment and action.",
    body: "Strategy becomes meaningful when it changes what leaders do. Yadid helps translate understanding into decisions, priorities, strategic initiatives, relationships, communications, convenings, commitments, implementation, and learning.",
    close: "And when circumstances change, we help leaders interpret again.",
  },
];

export const OUTCOMES = [
  {
    title: "See clearly.",
    body: "Understand the situation beneath the surface. Clarify what matters, what is changing, what is being missed, and where the real opportunities and risks lie.",
  },
  {
    title: "Connect wisely.",
    body: "Navigate the people, communities, institutions, and relationships surrounding the moment with credibility and care.",
  },
  {
    title: "Move confidently.",
    body: "Translate understanding into judgment, decisions, relationships, and action.",
  },
];

export const CAPABILITIES = [
  {
    slug: "trusted-advisory",
    title: "Trusted Advisory",
    teaser:
      "Ongoing strategic counsel for leaders navigating complex decisions, relationships, opportunities, and institutional environments.",
    headline: "A trusted thinking partner when the situation keeps moving.",
    body: "Some challenges cannot be resolved through a single project. They evolve. New information emerges. Relationships shift. Opportunities appear. Decisions create new questions. Through Trusted Advisory, Yadid provides ongoing strategic counsel and judgment with enough proximity to understand the context as it develops.",
    list: [
      "Executive counsel",
      "Strategic interpretation",
      "Relationship stewardship",
      "Decision support",
      "Opportunity assessment",
      "Institutional navigation",
      "Strategic communication",
      "Trusted access",
      "Ongoing implementation guidance",
    ],
    note: "Best suited for leaders who need a trusted advisor close enough to understand the evolving situation rather than episodic consulting support.",
  },
  {
    slug: "strategic-initiatives",
    title: "Strategic Initiatives",
    teaser:
      "Focused advisory engagements designed to move consequential opportunities or challenges from understanding to strategy to action.",
    headline: "Move a consequential priority from possibility to action.",
    body: "Strategic Initiatives provide focused advisory support around a defined opportunity, challenge, partnership, or institutional priority.",
    list: [
      "Strategic assessment",
      "Stakeholder intelligence",
      "Relationship mapping",
      "Strategic framing",
      "Initiative architecture",
      "Partnership strategy",
      "Activation planning",
      "Implementation guidance",
    ],
    note: "Engagements move through three movements — Assessment, Blueprint, and Activation — adapting to what is learned along the way.",
  },
  {
    slug: "executive-convenings",
    title: "Executive Convenings",
    teaser:
      "Strategic design and stewardship of gatherings where relationships, conversation, judgment, and outcomes matter.",
    headline: "Design the room around the outcome.",
    body: "A consequential gathering is not successful merely because the right people attended. The question is what the gathering made possible. Yadid advises on convenings where trust, conversation, relationship, alignment, and follow-through matter.",
    list: [
      "Strategic purpose",
      "Participant architecture",
      "Relationship considerations",
      "Invitation strategy",
      "Agenda design",
      "Executive preparation",
      "Facilitation",
      "Relationship stewardship",
      "Follow-up strategy",
      "Post-convening recommendations",
    ],
    note: "Yadid is not an event-production company. Our role is to help create the strategic and relational conditions for the gathering to matter.",
  },
  {
    slug: "communication-facilitation",
    title: "Executive Communication & Facilitation",
    teaser:
      "Counsel and facilitation for leaders communicating across sensitive institutional, cultural, relational, or public environments.",
    headline: "When what is said — and how it is heard — matters.",
    body: "Leaders often communicate across institutions, communities, cultures, faith traditions, and relationships with different histories and expectations. Yadid helps leaders communicate with greater clarity and judgment.",
    list: [
      "Executive messaging",
      "Strategic framing",
      "Speech and conversation preparation",
      "Cross-cultural interpretation",
      "Meeting facilitation",
      "Difficult conversations",
      "Stakeholder communication",
      "Institutional translation",
      "Executive correspondence",
    ],
    note: "This is not translation as a commodity. It is interpretation as an executive advisory function.",
  },
];

export const VALUES = [
  { title: "Trust", body: "Confidence must be earned." },
  { title: "Wisdom", body: "Information matters. Knowing what it means matters more." },
  { title: "Judgment", body: "Not every consequential question arrives with complete information." },
  { title: "Stewardship", body: "Relationships and institutional trust should be handled with care." },
  { title: "Integrity", body: "Our counsel should remain worthy of the confidence placed in us." },
  { title: "Discretion", body: "What is entrusted to us is treated accordingly." },
  { title: "Courage", body: "A trusted advisor must sometimes say what others will not." },
  { title: "Excellence", body: "Preparation and execution are expressions of respect." },
  { title: "Relational Intelligence", body: "Strategy cannot be separated from the people through whom it moves." },
  { title: "Long-Term Thinking", body: "The best decision is not always the one that produces the fastest result." },
];

export const ENVIRONMENTS = [
  "Philanthropy",
  "Faith Community leadership",
  "Strategic partnerships",
  "Cross-cultural engagement",
  "Institutional relationships",
  "Public-facing leadership",
];

export const MOMENTS = [
  "A strategic opportunity whose success depends on trust.",
  "A relationship that could shape an institution's future.",
  "A community you need to understand before you can engage it well.",
  "A partnership with real potential — but real complexity.",
  "A decision whose consequences will outlive the meeting in which it is made.",
];

export const JOURNEY_THEMES = [
  {
    slug: "israel",
    name: "Israel",
    body: "Faith, history, modern society, Jewish identity, geopolitics, community, and relationship.",
    image: IMAGES.jerusalemWindow,
  },
  {
    slug: "sepharad",
    name: "Sepharad",
    body: "Spain through the lens of Jewish memory, exile, identity, coexistence, and the legacy carried into the Americas. Potential locations may include Madrid, Toledo, Córdoba, Sevilla, and Granada.",
    image: IMAGES.cloisterArcade,
  },
  {
    slug: "poland-memory",
    name: "Poland & Memory",
    body: "Kraków, Warsaw, and the camps of the Shoah — Jewish life, destruction, memory, and the responsibilities carried by history, alongside immersive historical and cultural exploration.",
    image: IMAGES.synagogueRed,
  },
  {
    slug: "jewish-latin-america",
    name: "Jewish Latin America",
    body: "From Guatemala's friendship with Israel, to the refuge of Sosúa in the Dominican Republic, to Buenos Aires and the age of Bolívar — Jewish presence woven into the founding, liberation, and life of the Americas.",
    image: IMAGES.facade,
  },
  {
    slug: "faith-encounter",
    name: "Faith & Encounter",
    body: "Journeys designed to deepen Jewish–Christian understanding and relationships.",
    image: IMAGES.synagogueGold,
  },
];

// Interactive Journey Map data. Real country borders are rendered from
// Natural Earth data (via d3-geo) using `countryId` (ISO 3166-1 numeric).
// `stops` carry real [lng, lat] coordinates; `routeOrder` (optional) lists
// stop indices for the drawn route (used for out-and-back legs).
export const JOURNEY_MAPS = [
  {
    slug: "israel",
    name: "Israel",
    countryId: "376",
    region: "The Levant · Eastern Mediterranean",
    intro:
      "A deliberately structured route — Jerusalem as our base, down to the wilderness and back, then north to finish in the Galilee — designed to maximize both impact and time.",
    routeOrder: [0, 1, 2, 1, 3],
    stops: [
      {
        city: "Tel Aviv",
        image: "https://images.unsplash.com/photo-1695910410678-6731d8577dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxUZWwlMjBBdml2JTIwTWVkaXRlcnJhbmVhbiUyMHNreWxpbmV8ZW58MHx8fHwxNzg2OTQwMTkxfDA&ixlib=rb-4.1.0&q=85",
        label: "Arrival & the modern nation",
        body:
          "Land on the Mediterranean and meet the builders, journalists, and civic leaders shaping Israel's present — its debates, aspirations, and tensions.",
        coords: [34.78, 32.08],
        labelDir: "left",
      },
      {
        city: "Jerusalem",
        image: "https://images.unsplash.com/photo-1549575483-14686a641c28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxKZXJ1c2FsZW0lMjBvbGQlMjBjaXR5JTIwd2VzdGVybiUyMHdhbGx8ZW58MHx8fHwxNzg2OTQwMTkxfDA&ixlib=rb-4.1.0&q=85",
        label: "The Old City & our base",
        body:
          "Ascend to Jerusalem — the Western Wall, the four quarters, and Yad Vashem, encountered slowly and with care. The city becomes our base, and we return to it before heading north.",
        coords: [35.21, 31.77],
        labelDir: "right",
      },
      {
        city: "Dead Sea, Qumran & Masada",
        image: "https://images.unsplash.com/photo-1613412666192-af7fdde10060?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxNYXNhZGElMjBmb3J0cmVzcyUyMERlYWQlMjBTZWElMjBJc3JhZWx8ZW58MHx8fHwxNzg2OTQwMTkxfDA&ixlib=rb-4.1.0&q=85",
        label: "Descent to the wilderness",
        body:
          "Descend through the Judean desert to the lowest place on earth — Qumran and the Dead Sea Scrolls, and the fortress of Masada — then return to Jerusalem by the same road, the city seen anew.",
        coords: [35.39, 31.44],
        labelDir: "right",
      },
      {
        city: "Galilee",
        image: "https://images.unsplash.com/photo-1678134017317-4edd53da833d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxTZWElMjBvZiUyMEdhbGlsZWUlMjBsYW5kc2NhcGUlMjBJc3JhZWx8ZW58MHx8fHwxNzg2OTQwMTkxfDA&ixlib=rb-4.1.0&q=85",
        label: "North, to finish",
        body:
          "Travel north to close the journey in the green hills and shoreline of the Galilee — landscape, water, and a facilitated reflection on what changed in how you see.",
        coords: [35.53, 32.79],
        labelDir: "right",
      },
    ],
  },
  {
    slug: "sepharad",
    name: "Sepharad",
    countryId: "724",
    bbox: [-10, 35, 5, 44],
    region: "The Iberian Peninsula · Spain",
    intro:
      "Tracing both the flourishing and the fracture — the architecture of coexistence and the legacy carried into exile.",
    stops: [
      {
        city: "Madrid",
        image: "https://images.unsplash.com/photo-1570135460230-1407222b82a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxNYWRyaWQlMjBTcGFpbiUyMGNpdHlzY2FwZXxlbnwwfHx8fDE3ODY5NDAxOTF8MA&ixlib=rb-4.1.0&q=85",
        label: "Arrival in the capital",
        body:
          "Begin in Madrid before turning south toward the cities of medieval Sepharad and the world they once held.",
        coords: [-3.70, 40.42],
        labelDir: "right",
      },
      {
        city: "Toledo",
        image: "https://images.unsplash.com/photo-1616467396672-0354ca500e5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxUb2xlZG8lMjBTcGFpbiUyMG9sZCUyMGNpdHklMjByaXZlcnxlbnwwfHx8fDE3ODY5NDAxOTF8MA&ixlib=rb-4.1.0&q=85",
        label: "City of three cultures",
        body:
          "Walk the former Jewish quarter and the great synagogues turned churches — coexistence written into stone, and its limits.",
        coords: [-4.02, 39.86],
        labelDir: "left",
      },
      {
        city: "Córdoba",
        image: "https://images.unsplash.com/photo-1632904080322-e71e16a5987f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxDb3Jkb2JhJTIwTWV6cXVpdGElMjBhcmNoZXMlMjBTcGFpbnxlbnwwfHx8fDE3ODY5NDAxOTF8MA&ixlib=rb-4.1.0&q=85",
        label: "Capital of the Sephardic world",
        body:
          "Considered today the capital of Sepharad — the heart of the Sephardic world. The Mezquita and the world of Maimonides, an era when learning crossed every boundary of faith and language.",
        coords: [-4.78, 37.89],
        labelDir: "left",
      },
      {
        city: "Sevilla",
        image: "https://images.unsplash.com/photo-1559386081-325882507af7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxTZXZpbGxlJTIwU3BhaW4lMjBwbGF6YSUyMGRlJTIwZXNwYW5hfGVufDB8fHx8MTc4Njk0MDE5MXww&ixlib=rb-4.1.0&q=85",
        label: "Prosperity & the turning",
        body:
          "How flourishing gave way to expulsion, and what the community chose to carry with them into exile.",
        coords: [-5.99, 37.39],
        labelDir: "left",
      },
      {
        city: "Granada",
        image: "https://images.unsplash.com/photo-1620677368158-32b1293fac36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxBbGhhbWJyYSUyMEdyYW5hZGElMjBTcGFpbnxlbnwwfHx8fDE3ODY5NDAxOTF8MA&ixlib=rb-4.1.0&q=85",
        label: "1492, the last chapter",
        body:
          "The Alhambra and the edict of expulsion — an ending that became a beginning across the ocean.",
        coords: [-3.60, 37.18],
        labelDir: "bottom",
      },
    ],
  },
  {
    slug: "poland-memory",
    name: "Poland & Memory",
    countryId: "616",
    region: "Central Europe · Poland",
    intro:
      "Kraków, Warsaw, and the sites of the Shoah — Jewish life, the camps, and memory, held with the care they demand.",
    stops: [
      {
        city: "Warsaw",
        image: "https://images.unsplash.com/photo-1553422734-fd8dd260a116?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxXYXJzYXclMjBvbGQlMjB0b3duJTIwUG9sYW5kJTIwY29sb3JmdWx8ZW58MHx8fHwxNzg2OTQwMjA4fDA&ixlib=rb-4.1.0&q=85",
        label: "The Ghetto & the life before",
        body:
          "Prewar Jewish Warsaw and the POLIN Museum, the Ghetto and Umschlagplatz — a whole world, refused reduction to its destruction.",
        coords: [21.01, 52.23],
        labelDir: "right",
      },
      {
        city: "Treblinka",
        image: "https://images.unsplash.com/photo-1759052081044-cd2813bf9572?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtZW1vcmlhbCUyMHN0b25lcyUyMGZvcmVzdCUyMHJlbWVtYnJhbmNlfGVufDB8fHx8MTc4Njk0MDIwOHww&ixlib=rb-4.1.0&q=85",
        label: "Beyond the trees",
        body:
          "The death camp northeast of Warsaw, where much of the city's Jewish community perished — a place of silence and memorial stones.",
        coords: [22.05, 52.63],
        labelDir: "right",
      },
      {
        city: "Lublin & Majdanek",
        image: "https://images.pexels.com/photos/36933236/pexels-photo-36933236.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        label: "Learning & the camp on the edge",
        body:
          "A great center of Jewish scholarship — the world of the yeshiva — and the Majdanek camp preserved on the city's very edge.",
        coords: [22.57, 51.25],
        labelDir: "right",
      },
      {
        city: "Kraków & Kazimierz",
        image: "https://images.unsplash.com/photo-1629814695997-1d46fa818d19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxLcmFrb3clMjBLYXppbWllcnolMjBKZXdpc2glMjBxdWFydGVyJTIwc3RyZWV0fGVufDB8fHx8MTc4Njk0MDIwOHww&ixlib=rb-4.1.0&q=85",
        label: "The quarter & the living city",
        body:
          "The synagogues, courtyards, and cultural life of Kazimierz; Schindler's Factory and the story of Płaszów — memory as a living, not only mournful, act.",
        coords: [19.94, 50.06],
        labelDir: "left",
      },
      {
        city: "Auschwitz-Birkenau",
        image: "https://images.unsplash.com/photo-1721150227346-291a4e8dfc97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxBdXNjaHdpdHolMjBCaXJrZW5hdSUyMG1lbW9yaWFsJTIwcmFpbHdheSUyMHRyYWNrfGVufDB8fHx8MTc4Njk0MDIwOHww&ixlib=rb-4.1.0&q=85",
        label: "The weight of Auschwitz",
        body:
          "A slow, guided encounter with the largest of the camps, held with the seriousness it demands — followed by a facilitated reflection on responsibility.",
        coords: [19.23, 50.03],
        labelDir: "bottom",
      },
    ],
  },
  {
    slug: "jewish-latin-america",
    name: "Jewish Latin America",
    group: true,
    children: [
      {
        slug: "guatemala",
        name: "Guatemala",
        countryId: "320",
        region: "Central America · Guatemala",
        intro:
          "A steadfast friend of Israel — and a highland town on Lake Atitlán that became a home away from home.",
        stops: [
          {
            city: "Guatemala City",
            image: "https://images.unsplash.com/photo-1785353442061-2e3e2931e7ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxHdWF0ZW1hbGElMjBDaXR5JTIwc2t5bGluZXxlbnwwfHx8fDE3ODY5NDAyMDh8MA&ixlib=rb-4.1.0&q=85",
            label: "A landmark friendship",
            body:
              "The Jewish community of the capital, and Guatemala's landmark friendship with Israel — from its pivotal role in the 1947 UN vote to being among the first nations to move its embassy to Jerusalem.",
            coords: [-90.51, 14.63],
            labelDir: "right",
          },
          {
            city: "Antigua Guatemala",
            image: "https://images.unsplash.com/photo-1762870714919-ec8362c26dfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxBbnRpZ3VhJTIwR3VhdGVtYWxhJTIwY29sb25pYWwlMjBzdHJlZXQlMjB2b2xjYW5vJTIwYXJjaHxlbnwwfHx8fDE3ODY5NDAyMDh8MA&ixlib=rb-4.1.0&q=85",
            label: "The colonial heart",
            body:
              "Cobbled streets and baroque ruins in the shadow of volcanoes — the former colonial capital and the country's cultural jewel.",
            coords: [-90.73, 14.56],
            labelDir: "bottom",
          },
          {
            city: "San Pedro La Laguna",
            image: "https://images.unsplash.com/photo-1669025467316-a1bff8696c36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxMYWtlJTIwQXRpdGxhbiUyMEd1YXRlbWFsYSUyMHZvbGNhbm98ZW58MHx8fHwxNzg2OTQwMjA4fDA&ixlib=rb-4.1.0&q=85",
            label: "The Central American Jerusalem",
            body:
              "The town the Wall Street Journal called the \u201cCentral American Jerusalem,\u201d home to a living Israeli and Chabad community. Hebrew signs stand beside Spanish and English along the streets, and some of the best authentic Israeli food is served overlooking the beauty of Lake Atitlán.",
            coords: [-91.27, 14.69],
            labelDir: "left",
          },
        ],
      },
      {
        slug: "dominican-republic",
        name: "Dominican Republic",
        countryId: "214",
        region: "The Caribbean · Hispaniola",
        intro:
          "Founding and refuge — a nation shaped in part by Jewish hands, a town built by those who fled, and the mountains, valleys, and coasts in between.",
        stops: [
          {
            city: "Sosúa",
            image: "https://images.unsplash.com/photo-1596396967820-414435bbff2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxTb3N1YSUyMGJlYWNoJTIwRG9taW5pY2FuJTIwUmVwdWJsaWN8ZW58MHx8fHwxNzg2OTQwMjI2fDA&ixlib=rb-4.1.0&q=85",
            label: "Refuge & the Trujillo era",
            body:
              "Begin with the Jewish story: a north-coast town founded by Jewish refugees who fled the Second World War. Meet descendants of those communities, visit the museum, and reckon with the Trujillo era — one of the most consequential chapters in the country's history.",
            coords: [-70.52, 19.75],
            labelDir: "right",
          },
          {
            city: "Puerto Plata",
            image: "https://images.pexels.com/photos/38810522/pexels-photo-38810522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            label: "The amber coast",
            body:
              "A Victorian city on the Atlantic — the Fortaleza San Felipe, the seaside Malecón, and the amber for which this coast is famous, rising to the peak of Isabel de Torres.",
            coords: [-70.69, 19.79],
            labelDir: "left",
          },
          {
            city: "Santiago",
            image: "https://images.unsplash.com/photo-1667401101616-16241aef804c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxTYW50aWFnbyUyMERvbWluaWNhbiUyMFJlcHVibGljJTIwbW9udW1lbnR8ZW58MHx8fHwxNzg2OTQwMjI2fDA&ixlib=rb-4.1.0&q=85",
            label: "The Cibao heartland",
            body:
              "The nation's second city and cultural heart of the fertile Cibao valley — its monument, its music, and the tobacco traditions that shaped the region.",
            coords: [-70.70, 19.45],
            labelDir: "left",
          },
          {
            city: "Jarabacoa",
            image: "https://images.pexels.com/photos/38413304/pexels-photo-38413304.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            label: "The mountain interior",
            body:
              "In the heart of the Cordillera Central — pine forests, rivers, and waterfalls in the town they call the city of eternal spring; a place to slow down and breathe.",
            coords: [-70.63, 19.12],
            labelDir: "left",
          },
          {
            city: "Santo Domingo",
            image: "https://images.pexels.com/photos/31749062/pexels-photo-31749062.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            label: "Founding & roots",
            body:
              "The oldest city in the Americas, and the founding of the Dominican nation — where we explore the Jewish contribution to its formation and the possible Jewish roots of its founders.",
            coords: [-69.93, 18.49],
            labelDir: "bottom",
          },
          {
            city: "Punta Cana",
            image: "https://images.unsplash.com/photo-1569700946659-fe1941c71fe4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxQdW50YSUyMENhbmElMjBiZWFjaCUyMHBhbG0lMjB0cmVlc3xlbnwwfHx8fDE3ODY5NDAyMjZ8MA&ixlib=rb-4.1.0&q=85",
            label: "The eastern shore",
            body:
              "Close on the palm-lined beaches of the east — turquoise water and warm calm, time to reflect on all the journey has held.",
            coords: [-68.40, 18.58],
            labelDir: "bottom",
          },
        ],
      },
      {
        slug: "argentina",
        name: "Argentina",
        countryId: "032",
        bbox: [-74, -56, -53, -21],
        region: "The Southern Cone · Argentina",
        intro:
          "From the age of Bolívar to the largest Jewish community in Latin America — and the colony they called the Jerusalem of Argentina.",
        stops: [
          {
            city: "Buenos Aires",
            image: "https://images.unsplash.com/photo-1678838032358-d5ef71b283db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxCdWVub3MlMjBBaXJlcyUyMEFyZ2VudGluYSUyMGNpdHklMjBvYmVsaXNrfGVufDB8fHx8MTc4Njk0MDIyNnww&ixlib=rb-4.1.0&q=85",
            label: "The great community & liberation",
            body:
              "Home to the largest Jewish community after Israel and New York — the neighborhood of Once, the institutions and culture of today, and a history reaching back to the age of Simón Bolívar and the Jewish figures who helped liberate the Americas.",
            coords: [-58.38, -34.60],
            labelDir: "right",
          },
          {
            city: "Moisés Ville",
            image: "https://images.unsplash.com/photo-1707589884852-f0dbc72581d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxydXJhbCUyMHN5bmFnb2d1ZSUyMHBhbXBhcyUyMEFyZ2VudGluYSUyMGNvdW50cnlzaWRlfGVufDB8fHx8MTc4Njk0MDIyNnww&ixlib=rb-4.1.0&q=85",
            label: "The Jerusalem of Argentina",
            body:
              "The famed Jewish agricultural colony on the pampas — founded by immigrants and known as the \u201cJerusalem of Argentina,\u201d with its synagogues, cemetery, and the living memory of a pioneering community.",
            coords: [-61.46, -30.72],
            labelDir: "left",
          },
        ],
      },
    ],
  },
];

export const JOURNEY_INCLUDES = [
  "Historical interpretation",
  "Scholars and subject experts",
  "Community encounters",
  "Faith leaders",
  "Cultural experiences",
  "Private conversations",
  "Institutional visits",
  "Sites of memory",
  "Guided reflection",
  "Relationship-building",
  "Strategic context",
];

export const JOURNEY_AUDIENCES = [
  "Senior leaders",
  "Pastors and faith leaders",
  "Foundation leadership",
  "Institutional boards",
  "Executive cohorts",
  "Emerging leaders",
  "Philanthropic communities",
  "Educational groups",
  "Organizations seeking deeper cultural understanding",
];

export const INSIGHTS = [
  {
    slug: "strategy-moves-through-relationships",
    category: "Relationships & Strategy",
    date: "May 2026",
    title: "Strategy moves through relationships",
    excerpt:
      "The most sophisticated strategy can fail when trust is absent. A reflection on why relational intelligence is a strategic discipline, not a soft one.",
    body: [
      "Leaders are trained to analyze. They are rarely trained to read the relational field in which their strategy will actually move. Yet the difference between a strategy that succeeds and one that stalls is often not the quality of the analysis. It is the condition of the relationships that must carry it.",
      "Trust is not evenly distributed. It exists in some places and must be earned in others. Recognizing where credibility already lives — and where it does not yet — is the first act of a serious strategy.",
      "The question is rarely only technical. It is who understands the moment, who is trusted to speak into it, and whether the relationships surrounding it are strong enough to carry the weight of what comes next.",
    ],
  },
  {
    slug: "listening-before-prescribing",
    category: "Leadership & Judgment",
    date: "April 2026",
    title: "Listening before prescribing",
    excerpt:
      "Most advice arrives too early. A short argument for understanding the strategic reality before offering a single recommendation.",
    body: [
      "The temptation in advisory work is to arrive with a framework and force the situation into it. It is faster. It looks decisive. And it frequently misreads the room.",
      "Listening is not a courtesy that precedes the real work. It is the work. To listen well is to attend to leaders, stakeholders, history, context, and what remains unsaid — and to resist the comfort of an answer until the situation is understood.",
      "The objective is not more advice. It is better judgment.",
    ],
  },
  {
    slug: "understanding-requires-going-there",
    category: "History & Memory",
    date: "March 2026",
    title: "Sometimes understanding requires going there",
    excerpt:
      "Some things cannot be understood fully from a conference room. On the value of encountering the place, the story, and the people directly.",
    body: [
      "There is a kind of understanding that only arrives in the presence of the place. To stand inside a history, to meet the people who carry it, to hear the story where it happened — this changes how a leader sees long after they return.",
      "A journey designed well is not a tour. It is a question worth exploring, given room to be lived rather than merely described.",
      "Travel is the medium. Understanding is the purpose.",
    ],
  },
];

export const JOURNEYS = {
  israel: {
    slug: "israel",
    name: "Israel",
    tagline: "Faith, history, and the modern life of an ancient people.",
    hero: IMAGES.jerusalemWindow,
    question: "What does it mean to understand a place that so many claim to already know?",
    overview: [
      "Israel is not a single story. It is faith and statecraft, ancient stone and contemporary innovation, memory and argument, all held in a space smaller than most imagine. Leaders often arrive with impressions. They leave with questions worth carrying.",
      "The route is deliberately structured — Jerusalem as our base, a descent to the wilderness of the Dead Sea and back, and a finish in the Galilee — designed to maximize both impact and time, and to move between the sacred and the civic.",
    ],
    arc: [
      { title: "Tel Aviv — arrival", body: "Land on the Mediterranean coast and meet the builders, journalists, and civic leaders shaping Israel's present — its debates, aspirations, and tensions." },
      { title: "Jerusalem — the ascent", body: "Enter the Old City before the crowds — the Western Wall, the quarters, and Yad Vashem, encountered slowly and with care. Jerusalem becomes our base." },
      { title: "Down to the Dead Sea — Qumran & Masada", body: "Descend through the Judean desert to the lowest place on earth — Qumran and the Dead Sea Scrolls, and the fortress of Masada, resolve written into stone." },
      { title: "Return to Jerusalem", body: "Come back by the same road, the city seen anew — time to let the wilderness and the sacred settle together." },
      { title: "North, to the Galilee", body: "Finish in the green hills and shoreline of the Galilee — landscape, water, and a facilitated reflection on what changed in how you see." },
    ],
    gallery: [IMAGES.jerusalemStair, IMAGES.jerusalemWindow, IMAGES.cloisterLight],
    reflection: "Understanding Israel does not mean agreeing about it. It means being able to hold its complexity with more care than you did before.",
  },
  sepharad: {
    slug: "sepharad",
    name: "Sepharad",
    tagline: "Memory, exile, coexistence, and a legacy carried across an ocean.",
    hero: IMAGES.cloisterArcade,
    question: "What is carried forward when a people is expelled from a homeland it helped build?",
    overview: [
      "Medieval Spain was, for a time, a place of extraordinary cultural exchange — Jewish, Christian, and Muslim life woven together in cities of learning. Then came expulsion. This journey traces both the flourishing and the fracture.",
      "Through Toledo, Córdoba, Sevilla, and Granada, leaders encounter the architecture of coexistence and its collapse — and follow the Sephardic legacy as it traveled into the Americas, shaping communities that endure today.",
    ],
    arc: [
      { title: "Toledo, city of three cultures", body: "Walk the former Jewish quarter and the great synagogues turned churches — coexistence written into stone, and its limits." },
      { title: "Córdoba's golden age", body: "Considered today the capital of Sepharad — the heart of the Sephardic world. The Mezquita and the world of Maimonides, an era when learning crossed every boundary." },
      { title: "Sevilla and the turning", body: "How prosperity gave way to expulsion, and what the community chose to carry into exile." },
      { title: "Granada, the last chapter", body: "The Alhambra and 1492 — an ending that became a beginning elsewhere." },
      { title: "Across the ocean", body: "Trace the Sephardic diaspora into the Americas through conversation with historians and living communities." },
      { title: "What memory asks", body: "A guided reflection on exile, identity, and the responsibility of remembering well." },
    ],
    gallery: [IMAGES.cloisterHall, IMAGES.columns, IMAGES.cloisterArcade],
    reflection: "Sepharad is a study in how identity survives displacement — and how memory, carefully stewarded, becomes a form of belonging.",
  },
  "poland-memory": {
    slug: "poland-memory",
    name: "Poland & Memory",
    tagline: "Kraków, Warsaw, the camps, and the memory that leadership must carry.",
    hero: IMAGES.synagogueRed,
    question: "How do we stand honestly before a history this heavy — and lead differently because of it?",
    overview: [
      "Before the war, Poland was the heart of Jewish life in Europe — its scholarship, its music, its ordinary streets. This journey begins there, with the life, refusing to reduce that world to its destruction.",
      "From Kraków and Warsaw it moves, with care, through the sites of the Shoah — Auschwitz-Birkenau, Majdanek, and Treblinka — and the ghettos and quarters where communities lived and were lost. Immersive historical and cultural encounters accompany the memory throughout, because some places should not be faced alone.",
    ],
    arc: [
      { title: "Warsaw — the Ghetto and the life before", body: "Prewar Jewish Warsaw and the POLIN Museum, the Ghetto and Umschlagplatz — the texture of a whole world, and the shape of its loss." },
      { title: "Treblinka — beyond the trees", body: "The death camp northeast of Warsaw, where much of the city's Jewish community perished, encountered slowly and with the silence it demands." },
      { title: "Lublin and Majdanek", body: "A great center of Jewish learning — the world of the yeshiva — and the Majdanek camp preserved on the city's very edge." },
      { title: "Kraków and Kazimierz", body: "The synagogues, courtyards, and cultural life of Kazimierz; Schindler's Factory and the story of Płaszów — memory as a living, not only mournful, act." },
      { title: "Auschwitz-Birkenau", body: "A slow, guided encounter with the largest of the camps, held with the utmost care and seriousness." },
      { title: "Responsibility, carried forward", body: "A facilitated conversation on what this history asks of leaders now — about vigilance, dignity, and moral courage." },
    ],
    gallery: [IMAGES.krakowStreet, IMAGES.krakowSquare, IMAGES.synagogueGold],
    reflection: "Memory is not only about the past. It is a discipline that shapes how leaders recognize what matters, and what they will not allow to be repeated.",
  },
  "jewish-latin-america": {
    slug: "jewish-latin-america",
    name: "Jewish Latin America",
    tagline: "Founding, liberation, and refuge — Jewish presence woven into the Americas.",
    hero: IMAGES.facade,
    question: "How does a people become fully part of a new world while remaining fully itself?",
    overview: [
      "Jewish history is woven into Latin American identity in ways often overlooked — through founding and liberation, migration and refuge, culture and community that took root across the continent in distinct forms.",
      "This journey moves from Guatemala to the Dominican Republic to Argentina, encountering a living history: nations Israel counts among its friends, towns built by refugees, and a presence reaching back to the age of Simón Bolívar.",
    ],
    arc: [
      { title: "Guatemala — the Central American Jerusalem", body: "One of Israel's staunchest allies on the world stage, and the town the Wall Street Journal called the \u201cCentral American Jerusalem\u201d — an exploration of why this friendship runs so deep." },
      { title: "Sosúa and the Trujillo era", body: "A Dominican town founded by Jewish refugees fleeing the Second World War. Meet descendants, visit the museum, and reckon with the Trujillo era — one of the most consequential chapters in the nation's history." },
      { title: "Founders and roots", body: "Explore the Jewish contribution to the formation of the Dominican nation, and the possible Jewish roots of its founders." },
      { title: "Buenos Aires — liberation", body: "Trace a Jewish presence reaching back to the age of Simón Bolívar, and the figures who played a role in the liberation of the Americas." },
      { title: "A living community", body: "Encounter the largest Jewish community after Israel and New York — its institutions, culture, and civic life today." },
      { title: "What travels", body: "A facilitated reflection on founding, refuge, liberation, and the making of home." },
    ],
    gallery: [IMAGES.columns, IMAGES.facade, IMAGES.ledger],
    reflection: "Jewish Latin America is a study in belonging without erasure — a reminder that identity and integration need not be opposites.",
  },
  "faith-encounter": {
    slug: "faith-encounter",
    name: "Faith & Encounter",
    tagline: "Journeys designed to deepen Jewish–Christian understanding and relationship.",
    hero: IMAGES.synagogueGold,
    question: "What becomes possible when leaders of different faiths truly understand one another?",
    overview: [
      "Some of the most consequential relationships in public life cross lines of faith. Yet these relationships are often built on assumption rather than understanding. This journey is designed to change that.",
      "Through shared study, honest encounter, and time in places sacred to more than one tradition, Jewish and Christian leaders come to understand each other's histories, wounds, and hopes — and build the trust that meaningful partnership requires.",
    ],
    arc: [
      { title: "Beginning with story", body: "Each participant's own tradition, told and heard — the foundation of genuine encounter." },
      { title: "Shared sacred ground", body: "Visit places meaningful to both traditions, learning to see them through another's eyes." },
      { title: "Difficult history, honestly", body: "Face the harder chapters of Jewish–Christian relations with candor and care." },
      { title: "Study together", body: "Text and conversation with scholars from both traditions — understanding, not persuasion." },
      { title: "Building the relationship", body: "Facilitated dialogue that turns encounter into trust and the beginnings of partnership." },
      { title: "Return, together", body: "A closing reflection on how leaders carry this understanding into their institutions and communities." },
    ],
    gallery: [IMAGES.synagogueRed, IMAGES.cloisterLight, IMAGES.conversation],
    reflection: "Faith & Encounter is built on a simple conviction: trust between traditions is not the absence of difference, but the fruit of understanding it.",
  },
};
